import React from "react"
import PageContainer from "../containers/PageContainer"
import HeadData from "../data/HeadData"
import PageHeaderImageBg from '../headers/PageHeaderImageBg'
import PageHeaderText from "../headers/PageHeaderText"
import HeaderNav from "../navigation/HeaderNav"
import HomeAffiliationSection from "../sections/HomeAffiliationSection"
import CTASection from "../sections/CTASection"
import PagePrivacySection from "../sections/PagePrivacySection"

export default () => (
  <PageContainer>
    <HeadData 
      title='Privacy Policy' 
      description='It is the policy Interpacific Asset Management to respect your privacy regarding any information we may collect from you across our website'
    />

    <PageHeaderImageBg>
      <HeaderNav />
      <PageHeaderText
        title='Privacy Policy'
      />
    </PageHeaderImageBg>

    <PagePrivacySection />

    <HomeAffiliationSection />

    <CTASection />
  </PageContainer>
)
